import React, { useEffect } from "react";
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import { selectLayoutType } from './store/selectors';
import { Routes, Route } from "react-router-dom";

import { layoutTypes } from "./constants/layout";

// Import all routes
import { authProtectedRoutes, publicRoutes } from "./routes";

import RouteTracker from './components/Common/RouteTracker';

// Import middlewares
import Authmiddleware from "./routes/route";

// Layout Formats
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Custom Axios
import axiosInstance from './utils/axiosInstance';
// Custom Hook
import useHandleUnauthorized from './hooks/useHandleUnauthorized';

import { refreshToken } from 'utils/authUtils';

// Before store is stable
import { persistor } from "./store";

import 'regex-named-groups';

// Import scss
import './App.css';
import "./assets/scss/theme.scss";
import "odometer/themes/odometer-theme-default.css";
import 'react-spring-bottom-sheet/dist/style.css';

const getLayout = (layoutType) => {
  let Layout = VerticalLayout;
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      Layout = VerticalLayout;
      break;
    case layoutTypes.HORIZONTAL:
      Layout = HorizontalLayout;
      break;
    default:
      break;
  }
  return Layout;
};

const App = () => {

  // Navigate the user to login page if not authorized in AxiosInstance
  useHandleUnauthorized();

  const layoutType = useSelector(selectLayoutType);
  const Layout = getLayout(layoutType);

  // Before store is stable
  useEffect(() => {
    persistor.purge();
  }, []);

  return (
    <React.Fragment>
      <RouteTracker>
        <Routes>

          {/* Public Routes */}
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <NonAuthLayout>
                  {route.component}
                </NonAuthLayout>
              }
              key={idx}
              exact
            />
          ))}

          {/* Protected Routes */}
          {authProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <Authmiddleware>
                  <Layout>
                    {route.component}
                  </Layout>
                </Authmiddleware>}
              key={idx}
              exact
            />
          ))}

        </Routes>
      </RouteTracker>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any
};

export default App;
